import { hasPermission } from '@shared/auth';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthContext } from '@web/auth';
import { UserTableView } from './-components/user-table-view';
import { Navigate } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { usersFiltersSchema } from '@shared/types';

export const Route = createFileRoute('/dashboard/admin/users')({
  component: UsersPage,
  beforeLoad: ({
    context: {
      auth: { user },
    },
  }) => {
    if (!user)
      throw redirect({
        to: '/auth/sign-in',
        search: { returnTo: location.pathname },
      });

    return {
      loggedInUser: user,
    };
  },
  validateSearch: zodSearchValidator(usersFiltersSchema),
});

function UsersPage() {
  const { user } = useAuthContext();

  if (!user) return null;

  if (!hasPermission(user, 'users_module', 'access')) {
    return <Navigate to="/dashboard" />;
  }

  return <UserTableView />;
}
